import {DomSmallUtils} from "./dom-utils";
declare var jQuery: JQueryStatic;

export class Utils {

	public static isNumeric(value: any): boolean {

		return !isNaN(parseFloat(value)) && isFinite(value);

	}

	public static getNavigatorLanguage(): string {
		return (navigator.languages && navigator.languages.length) ? navigator.languages[0] : navigator.language || 'en';
	}

	public static isNullOrEmpty(value: any): boolean {
		return value === null || value === undefined || value === '';
	}

	public static isAnyNullOrEmpty(...values: any[]): boolean {
		return values?.some(x => this.isNullOrEmpty(x)) ?? true;
	}

	public static get decimalSeparator(): string {
		return (1.1).toLocaleString().replace(/1/g, '');
	}
	
	// This way depends on browser language not system locale
	public static get thousandSeparator(): string {
		return (1111).toLocaleString().replace(/1/g, '');
	}

	public static isValue(value: any): boolean {

		return typeof (value) != "undefined" && value != null;

	}

	public static isScrolledHorizontally(div: HTMLElement) {

		const scrollSize = parseInt(div.scrollWidth + '');
		const viewportSize = Math.ceil(DomSmallUtils.outerWidthFull(div));

		if (scrollSize <= viewportSize) return false;
		else return true;
	}
	
	public static isEmpty(value: string): boolean {

		// TODO remove IF after strict checks
		if (typeof value !== 'string') {
			value = '' + value;
		}

		return (value.length === 0 || !value.trim());

	}

	public static isScrolledVertically(div: HTMLElement) {

		const scrollSize = parseInt(div.scrollHeight + '');
		const viewportSize = Math.ceil(DomSmallUtils.outerHeightFull(div));

		if (scrollSize <= viewportSize) return false;
		else return true;
	}

	private static foundZIndex: number = 0;
	
	public static getZIndex(el: Node): number {

		const util = this;

		const limitObj = document ? document.body : document;
		if (!el || el == limitObj) {
			const z = util.foundZIndex;
			const bodyZIndexes = Array.from((el as HTMLElement).children).map(a => parseFloat(getComputedStyle(a).getPropertyValue("z-index"))).filter(a => !isNaN(a));
			const bodyMaxZIndex = Math.max(...bodyZIndexes);
			util.foundZIndex = 0;
			return z > bodyMaxZIndex ? z : bodyMaxZIndex;
		}

		let index: number = 0;
		try {
			let zToParse = getComputedStyle(el as Element).getPropertyValue("z-index");

			const htmlEl = el as HTMLElement;
			if (htmlEl['style'] && htmlEl['style'].zIndex)
				zToParse = htmlEl['style'].zIndex;

			index = parseInt(zToParse);
		}
		catch (ex) {}

		if (!isNaN(index)) {

			util.foundZIndex = index;

		}

		return el.parentNode ? util.getZIndex(el.parentNode) : index;

	}

	public static getCookie(name: string): string {

		const matches = document.cookie.match(new RegExp(
			"(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
		));
		return matches ? decodeURIComponent(matches[1]) : '';

	}

	// Set new ConversationId if needed
	public static checkConversationId(): void {
		// If ConversationId is empty or we have gone from login page
		if (!window.localStorage.getItem('ConversationId')) {
			this.setConversationId();
		}

		// Remove old ActivityId from cookie, it was renamed to ConversationId
		document.cookie = `ActivityId=; path=/; expires=${new Date(0).toUTCString()}`;
	}

	// Set new ConversationId
	public static setConversationId(): void {
		// Add to localStorage
		window.localStorage.setItem('ConversationId', window['nextConversationId']);

		// Add to cookie
		var expire = new Date();
		expire.setFullYear(expire.getFullYear() + 100);

		document.cookie = `ConversationId=${window['nextConversationId']}; path=/; expires=${expire.toUTCString()}`;
	}

	// Clear stored ConversationId (used in logging)
	public static clearConversationId(): void {
		// Remove from localStorage
		window.localStorage.removeItem('ConversationId');

		// Remove from cookie
		document.cookie = `ConversationId=; path=/; expires=${new Date(0).toUTCString()}`;
	}

	public static deleteCookie(name: string) {
		document.cookie = `${name}=;Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
	}
}